import { Ref, computed, defineComponent, inject, ref } from 'vue';
import SVG from '@dts/shared/src/assets/svg';
import styles from './index.module.scss';
import { NButton, NDropdown } from 'naive-ui';
import { IPermission } from '@/hooks/usePermission';
import webConfig from '@dts/shared/src/utils/httpUrlConfig';
import { getToken } from '@dts/shared/src/utils/system';
import Typography from '@/components/TextFormat/FormatElements/Typography';
import { StepsID } from '@/view/Home/HomePage/components/TourSteps';
import { useModalStore } from '@/store/modal';

const Expand = defineComponent({
  setup: () => {
    const showExpandMenu = ref(false);
    const userPermission = inject<Ref<IPermission>>('userPermission');

    const modal = useModalStore();

    const toBack = () => {
      showExpandMenu.value = false;
      const token = getToken();
      setTimeout(() => {
        window.open(webConfig.backend + '#/?token=' + token);
      }, 100);
    };

    const options = computed(() => {
      const data = [
        {
          label: () => (
            <Typography.Text
              size={14}
              onClick={() => {
                // modal.glossary = true;
                window.open('https://atc.bmw-brilliance.cn/confluence/x/n-KGRg', '_blank');
              }}
            >
              Glossary
            </Typography.Text>
          ),

          key: 'Glossary',
          icon: () => (
            <div class={styles.icon}>
              <SVG.HeaderGlossarySVG />
            </div>
          ),
        },
        {
          label: () => (
            <Typography.Text
              size={14}
              onClick={() => {
                modal.feedback = true;
              }}
            >
              Feedback
            </Typography.Text>
          ),

          key: 'Feedback',
          icon: () => (
            <div class={styles.icon}>
              <SVG.FeedBackSVG />
            </div>
          ),
        },
      ];
      if (userPermission?.value) {
        data.push({
          label: () => (
            <div class={styles.text} onClick={toBack} onKeypress={() => {}}>
              Administrator
            </div>
          ),
          key: 'Administrator',
          icon: () => (
            <div class={styles.icon}>
              <SVG.Config />
            </div>
          ),
        });
      }
      return data;
    });

    const handleClick = () => {
      showExpandMenu.value = true;
    };

    return () => (
      <>
        <NDropdown
          show={showExpandMenu.value}
          options={options.value}
          onClickoutside={() => (showExpandMenu.value = false)}
        >
          <div>
            <NButton
              size="large"
              text
              class={styles.expand}
              onClick={handleClick}
              v-slots={{
                icon: () => <SVG.ExpandSVG />,
              }}
            >
              <div class={styles.btn} id={StepsID.feedbacks} />
            </NButton>
          </div>
        </NDropdown>
      </>
    );
  },
});
export default Expand;
